import {Component, ViewChild, TemplateRef, OnInit} from '@angular/core';
import {isSameDay, isSameMonth} from 'date-fns';
import { Subject } from 'rxjs';
import {CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView} from 'angular-calendar';
import * as moment from 'moment';
import 'moment/locale/es';
import Swal from 'sweetalert2';
import { CalendarService } from '../../services/calendar.service';
import {FilesService} from '../../services/files.service';
import {FileManagerRequirementComponent} from '../splasboard/legal-requirements/file-manager-requirement/file-manager-requirement.component';
import {NbDialogService} from '@nebular/theme';
import {DependencesService} from '../../services/dependences.service';
import { ActivatedRoute } from '@angular/router';
import { StationService } from '../../services/stations.service';
import { CustomRendererComponent } from '../splasboard/legal-requirements/custom-renderer.component';
import { LocalDataSource } from 'ng2-smart-table';

@Component({
  selector: 'ngx-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  stationId: string;
  loading: boolean = false;
  @ViewChild('modalContent', {static: true}) modalContent: TemplateRef<any>;

  // CALENDAR ATTRS
  events: CalendarEvent[] = [];
  view: CalendarView = CalendarView.Month;
  activeDayIsOpen: boolean = false;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  actions: CalendarEventAction[] = [
    {
      label: `<span class="hover-cursor-pointer ml-1">
                <img src="assets/images/icons/archivo.svg" class="img-fluid" width="20" alt="Agregar">
            </span>`,
      onClick: ({event}: { event: CalendarEvent }): void => {
        this.handleEvent('program', event);
      },
    },
    {
      label: `<span class="hover-cursor-pointer ml-1">
                <img src="assets/images/icons/edit.png" class="img-fluid" width="20" alt="Editar">
            </span>`,
      onClick: ({event}: { event: CalendarEvent }): void => {
        this.handleEvent('edit', event);
      },
    },
    {
      label: `<span class="hover-cursor-pointer ml-1">
                <img src="assets/images/icons/download.png" class="img-fluid" width="20" alt="Descargar">
            </span>`,
      onClick: ({event}: { event: CalendarEvent }): void => {
        this.handleEvent('download', event);
      },
    },
  ];
  colors: any = {
    red: {
      primary: '#ec454f',
      secondary: '#FAE3E3',
    },
    blue: {
      primary: '#1e90ff',
      secondary: '#D1E8FF',
    },
    yellow: {
      primary: '#f19a1a',
      secondary: '#FDF1BA',
    },
    green: {
      primary: '#1aab8b',
      secondary: '#FDF1BA',
    },
  };

  settings = {
    actions: false,
    columns: {
      name: {
        title: 'Nombre',
        filter: true
      },
      stage: {
        title: 'Etapa',
        filter: true,
      },
      periodicity: {
        title: 'Periodicidad',
        filter: true
      },
      dependences: {
        title: 'Dependencias',
        filter: true
      },
      date: {
        title: 'Calendarizado',
        filter: true
      },
      actions: {
        title: '',
        type: 'custom',
        renderComponent: CustomRendererComponent,
        onComponentInitFunction: (instance) => {
          // instance.save.subscribe(row => this.open(row) );
          // instance.cancelDeliver.subscribe(row => this.cancelDeliverConfirmation(row) );
          // instance.editRequirement.subscribe(row => this.editRequirement(row) );
          instance.openFileManagerByRequirement.subscribe(row => this.openFileManagerByRequirement(row.deliverable) );
        },
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };

  source: LocalDataSource = new LocalDataSource;

  refresh: Subject<any> = new Subject();
  downloading = false;

  // ATTR AUX
  deliverablesParent = [];
  deliverablesExpired = [];
  deliverablesDelivered = [];
  requirements = [];
  deliverables = [];
  formatDate = 'YYYY/MM/DD';
  moment = moment;
  dataLoaded = false;
  programmedParent: any = {}

  constructor (
    private calendarService: CalendarService,
    private filesService: FilesService,
    private dialogService: NbDialogService,
    private dependenceService: DependencesService,
    private route: ActivatedRoute,
    private stationService: StationService
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  async ngOnInit() { this.init(); }

  async init() {
    this.stationService.checkIfStationIdOrRefirect();
    await this.index();
  }

  async index() {
    this.loading = true;
    this.events = [];
    this.programmedParent = {}
    const [error, result] = await this.dependenceService.getDeliverablesByStationId(this.stationId) as any;
    this.loading = false;
    if (error) return console.error(error);
    this.deliverables = result.data;
    this.deliverablesParent = await result.data.filter(event => event.parent);
    this.source.load(this.deliverablesParent.map(deliverable => {
      const data: any = { date: deliverable.date, delivered: true, dependences: '', deliverable }
      if (deliverable.requirement) {
        data.name = deliverable.requirement.name
        data.stage = deliverable.requirement.stage
        data.periodicity = deliverable.requirement.periodicity
        for (const dependence of deliverable.requirement.dependences) data.dependences += dependence.acronym + '/'
      } else {
        data.name = deliverable.preference.data.name
        data.stage = deliverable.preference.data.stage
        data.periodicity = deliverable.preference.periodicity
        data.dependences = deliverable.preference.dependence.acronym
      }
      data.dependences = data.dependences.slice(0, -1)
      return data
    }))
    await this.fillDataCalendar();
  }

  async fillDataCalendar() {
    for (const deliverable of this.deliverablesParent) {
      const periodicity = (deliverable.station_legal_requirement_id) ? deliverable.preference.periodicity : deliverable.requirement.periodicity
      const title = ((!deliverable.station_legal_requirement_id) ? deliverable.requirement.name :
        deliverable.preference.requirement ? deliverable.preference.requirement.name : deliverable.preference.data.name)
      switch (periodicity.toLowerCase()) {
        case 'quincenal':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 15, 'dias', title);
          break;
        case 'mensual':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 1, 'month', title);
          break;
        case 'bimestral':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 2, 'month', title);
          break;
        case 'trimestral':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 3, 'month', title);
          break;
        case 'semestral':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 6, 'month', title);
          break;
        case 'anual':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 1, 'year', title);
          break;
        case 'bienal':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 2, 'year', title);
          break;
        case 'quinquenal':
          await this.fillPeriodicityDataIntoCalendarView(deliverable, 5, 'year', title);
          break;
          // UNIQ AND TEXT's WEAR
        default:
          await this.fillUniqDaraIntoCalendarView(deliverable, title);
          break;
      }
    }
  }

  async fillUniqDaraIntoCalendarView(deliverable: any, title: string) {
    if (deliverable.delivered) {
      this.events.push({
        id: deliverable.id,
        start: new Date(moment(deliverable.date).format(this.formatDate)),
        title,
        color: this.colors.green,
        cssClass: 'py-1',
        actions: [this.actions[1], this.actions[2]],
        meta: { fileUrl: deliverable.fileUrl, parent: deliverable.parent, isDelivered: true , deliverable },
      });
    } else {
      this.events.push({
        id: deliverable.id,
        start: new Date(moment(deliverable.date).format(this.formatDate)),
        title,
        color: this.colors.red,
        cssClass: 'py-1',
        actions: [this.actions[0]],
        meta: { fileUrl: 0, parent: deliverable.parent, isDelivered: false, deliverable },
      });
    }
  }

  async fillPeriodicityDataIntoCalendarView(deliverable: any, add: any, type: string, title: string) {
    const yearsToPastAndFutere = 2;
    let auxDate = moment();
    let afterDate = moment(deliverable.date, 'YYYY-MM-DD').subtract(yearsToPastAndFutere, 'year').format(this.formatDate);
    const whenYearsFilling = Number(moment(deliverable.date, 'YYYY-MM-DD').add(yearsToPastAndFutere, 'year').year());
    let continueFilling = true;
    do {

      const foundDeliverable = this.deliverables.find(item =>
        moment(item.date, 'YYYY-MM-DD').format(this.formatDate) === afterDate &&
        deliverable.legal_requirement_requirement_id === item.legal_requirement_requirement_id &&
        deliverable.station_legal_requirement_id === item.station_legal_requirement_id
      );
      if (foundDeliverable && foundDeliverable.delivered) {
        this.events.push({
          id: foundDeliverable.id,
          start: new Date(afterDate),
          title,
          color: this.colors.green,
          cssClass: 'py-1',
          actions: [this.actions[1], this.actions[2]],
          meta: {
            withDelivered: foundDeliverable.id,
            fileUrl: foundDeliverable.fileUrl,
            parent: foundDeliverable.parent,
            isDelivered: foundDeliverable.delivered,
            deliverable: foundDeliverable
          },
        });
      } else if (foundDeliverable) {

        this.events.push({
          id: foundDeliverable.id,
          start: new Date(afterDate),
          title,
          color: this.colors.red,
          cssClass: 'py-1',
          actions: [this.actions[0]],
          meta: {
            withDelivered: foundDeliverable.id,
            fileUrl: 0,
            parent: foundDeliverable.parent,
            isDelivered: foundDeliverable.delivered,
            deliverable: foundDeliverable
          },
        });
      } else {
        this.events.push({
          id: deliverable.id,
          start: new Date(afterDate),
          title,
          color: this.colors.red,
          cssClass: 'py-1',
          actions: [this.actions[0]],
          meta: {
            withDelivered: false,
            fileUrl: 0,
            parent: moment(deliverable.date).format(this.formatDate) === afterDate,
            isDelivered: false,
            deliverable
          },
        });
      }
      continueFilling = Number(auxDate.year()) < whenYearsFilling;
      auxDate = moment(afterDate).add(add, type);
      afterDate = auxDate.format(this.formatDate);
    } while (continueFilling);
  }

  alertFail() {
    Swal.fire({
      title: 'Oops',
      text: 'Algo ocurrió, por favor intenta más tarde',
      icon: 'error',
      confirmButtonText: 'Ok',
    });
  }

  successAlert() {
    Swal.fire({
      title: 'Ok',
      text: 'Documento guardado con éxito',
      icon: 'success',
      confirmButtonText: 'Ok',
    });
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      this.activeDayIsOpen = !((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0);
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map(iEvent => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  async handleEvent(action: string, event: any) {
    if (action === 'program' || action === 'edit') {
      this.openFileManagerByRequirement(event.meta.deliverable, moment(event.start).year().toString())
    } else if (action === 'download') {
      const deliverableFound = this.deliverables.find(deliverable => deliverable.id === event.id);
      if (!deliverableFound) return console.error('Error not found delivered');
      const a = document.createElement('a');
      a.hidden = true;
      a.target = '_blank';
      a.href = deliverableFound.files;
      a.click();
      a.remove();
    } else {
      console.error('No option list');
    }
  }

  setView(view: CalendarView) { this.view = view; }

  closeOpenMonthViewDay() { this.activeDayIsOpen = false; }

  async openFileManagerByRequirement(deliverable: any, year = '') {
    const deliverables = await this.deliverables.filter(deliver =>
      deliver.legal_requirement_requirement_id === deliverable.legal_requirement_requirement_id &&
      deliver.station_legal_requirement_id === deliverable.station_legal_requirement_id
    )
    const requirement = await deliverable.station_legal_requirement_id ? deliverable.preference : deliverable.requirement
    requirement.legal_requirement_dependence_id = deliverable.legal_requirement_dependence_id
    requirement.legal_requirement_requirement_id = deliverable.legal_requirement_requirement_id
    requirement.station_legal_requirement_id = deliverable.station_legal_requirement_id
    this.dialogService.open(FileManagerRequirementComponent, { hasScroll: true, context: { deliverables, requirement, stationId: this.stationId, year } }).onClose.subscribe(() => this.index());
  }

  async downloadFile(url) {
    this.downloading = true;
    await this.filesService.downloadFile(url);
    this.downloading = false;
  }
}
